module.exports = __webpack_public_path__ + "media/images/sp/stores/nagoya_ekimae/nagoya_ekimae_concept_01-a3f009c0e02ed297d3f9d56b63cabcbb.jpg";